import React from 'react';
import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';

const FloatingWrapper = styled.div`
  position: relative;
  height: 100%;
`

const Container = styled(Paper)`
  // position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  flex-direction: row;
  // width: 100px;
  background: white;
  padding: 5px 10px;
`

const FloatingSelect = ({
  children,
  ...other
}) => {

  return (
    <FloatingWrapper {...other}>
      <Container>
        {children}
      </Container>
    </FloatingWrapper>
  )
}

FloatingSelect.propTypes = {

};

FloatingSelect.defaultProps = {

};

export default FloatingSelect;
